import React from 'react';
import {FormattedNumber} from 'react-intl';

export function formatCurrency(num) {
  try {
    if (num) {
      num = parseFloat(num);
      num = num.toFixed(2);
    }
    return <FormattedNumber value={num} style={'currency'} currency={'USD'} />;
  } catch(e) {
    return <span>$ {num}</span>;
  }
}
export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
export function formatStaticCurrency(num) {
  try {
    if(!num) {
      return '-';
    }

    if (num) {
      num = parseFloat(Math.round(parseInt(num) * 100) / 100);
      num = num.toFixed(2);
    }

    let formattedValue = <FormattedNumber value={num} style={'currency'} currency={'USD'} />;
    let value = formattedValue.props.value;
    let currency = formattedValue.props.currency != null ? formattedValue.props.currency : '$';

    return currency + value;
  } catch(e) {
    return <span>$ {num}</span>;
  }
}
